/** @typedef {{ valid: boolean, formErrors?: Record<string, string>, rowErrors?: object[] }} MatchFormResult */

export function emptyRowErrors(rowCount) {
  return Array.from({ length: rowCount }, () => ({}));
}

export function mapYupFlatErrors(err, fields) {
  const formErrors = {};
  const errors = err.inner?.length ? err.inner : [err];
  const allowed = fields ? new Set(fields) : null;

  for (const e of errors) {
    const path = e.path || "";
    if (!path || path.includes("[") || path.includes(".")) continue;
    if (allowed && !allowed.has(path)) continue;
    formErrors[path] = e.message;
  }
  return formErrors;
}

export function mapYupAllFlatErrors(err) {
  const formErrors = {};
  const errors = err.inner?.length ? err.inner : [err];
  for (const e of errors) {
    const path = e.path || "";
    if (!path) continue;
    if (path.includes("[") || path.includes(".")) continue;
    formErrors[path] = e.message;
  }
  return formErrors;
}

export function applyMatchRowYupPath(formErrors, rowErrors, path, message) {
  const bracketMatch = path.match(/^matchRows\[(\d+)\]\.(\w+)$/);
  if (bracketMatch) {
    const idx = Number(bracketMatch[1]);
    const key = bracketMatch[2];
    if (idx < rowErrors.length) rowErrors[idx][key] = message;
    return;
  }

  const dotMatch = path.match(/^matchRows\.(\d+)\.(\w+)$/);
  if (dotMatch) {
    const idx = Number(dotMatch[1]);
    const key = dotMatch[2];
    if (idx < rowErrors.length) rowErrors[idx][key] = message;
    return;
  }

  if (path === "matchRows") {
    formErrors.matchRows = message;
    return;
  }

  if (path && !path.startsWith("matchRows")) {
    formErrors[path] = message;
  }
}

export function mapYupToMatchRowForm(err, rowCount) {
  const formErrors = {};
  const rowErrors = emptyRowErrors(rowCount);
  const errors = err.inner?.length ? err.inner : [err];

  for (const e of errors) {
    applyMatchRowYupPath(formErrors, rowErrors, e.path || "", e.message);
  }

  return { valid: false, formErrors, rowErrors };
}

export function runMatchRowFormSchema(schema, values, rowKey = "matchRows") {
  const rowCount = values[rowKey]?.length ?? 0;
  try {
    schema.validateSync(values, { abortEarly: false });
    return {
      valid: true,
      formErrors: {},
      rowErrors: emptyRowErrors(rowCount),
    };
  } catch (err) {
    if (err.name !== "ValidationError") throw err;
    return mapYupToMatchRowForm(err, rowCount);
  }
}

export function runFlatFormSchema(schema, values, fields) {
  try {
    schema.validateSync(values, { abortEarly: false });
    return { valid: true, errors: {} };
  } catch (err) {
    if (err.name !== "ValidationError") throw err;
    return { valid: false, errors: mapYupAllFlatErrors(err) };
  }
}

export function runSchemaWithContext(schema, values, context = {}) {
  try {
    schema.validateSync(values, { abortEarly: false, context });
    return { valid: true, context };
  } catch (err) {
    if (err.name !== "ValidationError") throw err;
    return { valid: false, err, context };
  }
}
